// extracted by mini-css-extract-plugin
module.exports = {"input":"Contact_input__bIlBr"};